import { useCallback, useContext } from 'react';
import { SortContext } from '../../utils/Sort/SortContext';
export function useSort(id) {
    const context = useContext(SortContext);
    if (context === undefined) {
        throw new Error('useSort must be used within a provider');
    }
    const order = context.id === id ? context.order : null;
    const handleSort = useCallback((event) => {
        if (context.onSort) {
            if (context.id !== id) {
                context.onSort(id, 'desc', event);
            }
            else {
                context.onSort(id, context.order === 'asc' ? 'desc' : 'asc', event);
            }
        }
    }, [id, context]);
    return { order, onSort: handleSort };
}
